import React from 'react';
import styles from './HorizontalNavigationLoading.module.css';
import { ITheme, ThemeProvider, getTheme, Shimmer, ShimmerElementType } from '@fluentui/react';

interface IHorizontalNavigationLoading {
    theme?: ITheme;
}

export const HorizontalNavigationLoading = (props: IHorizontalNavigationLoading) => {
    return (
        <ThemeProvider theme={props.theme ?? getTheme()} className={styles.root}>
            <Shimmer
                className={styles.sectionHeader}
                shimmerElements={[
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.line, height: 10, width: 100 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.line, height: 10, width: 100 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.line, height: 10, width: 100 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.line, height: 10, width: 100 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 },
                    { type: ShimmerElementType.line, height: 10, width: 100 },
                    { type: ShimmerElementType.gap, width: 15, height: 30 }
                ]} />
        </ThemeProvider>
    );
};